<div class="alert-container">
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show shadow-sm" role="alert">
    {{ successMessage }}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="closeAlert()"></button>
  </div>
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show shadow-sm" role="alert" (click)="closeErrorAlert()">
    {{ errorMessage }}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
</div>

<div class="container-fluid d-flex flex-column align-items-center" style="min-height: 100vh; background-color: #fafafa; padding: 2rem 0;"
  *ngIf="isStudentAllowed !== null; else loading">
  
  <!-- Header Card -->
  <div class="col-12 col-md-10 col-lg-8 col-xl-7">
    <div class="header-card">
      <div class="row align-items-center">
        <div class="col-12 col-md-8 mb-3 mb-md-0">
          <h1 class="page-title mb-0">Formulaire de demande d'assistance</h1>
        </div>
        <div class="col-12 col-md-4 d-flex justify-content-md-end justify-content-center">
          <img src="university-logo.svg" alt="Logo université Paris-Panthéon-Assas" class="img-fluid"
            style="max-height: 150px; min-height: 100px; object-fit: contain;">
        </div>
      </div>
    </div>
  </div>

  <!-- Not Authorized Message -->
  <div class="col-12 col-md-10 col-lg-8 col-xl-7">
    <ng-template #notAuthorized>
      <div class="alert alert-warning shadow-sm">
        <strong>Accès non autorisé</strong><br>
        {{ userNotAllowedMessage }}
      </div>
    </ng-template>
  </div>

  <!-- Form Card -->
  <div class="col-12 col-md-10 col-lg-8 col-xl-7" *ngIf="isStudentAllowed; else notAuthorized">
    <div class="form-card">
      <form #assistForm="ngForm" (ngSubmit)="onSubmit(assistForm)">
        
        <!-- Informations personnelles section -->
        <div class="mb-4">
          <h2 class="block-title mb-4">Informations personnelles</h2>
          
          <!-- Name Field -->
          <div class="mb-3">
            <label for="nickname" class="form-label">Nom et Prénom</label>
            <input type="text" class="form-control" id="nickname" name="nickname" required
              [(ngModel)]="studentName" disabled>
            <div *ngIf="assistForm.submitted && assistForm.controls['nickname']?.invalid">
              <small class="text-danger">Ce champ est requis.</small>
            </div>
          </div>

          <!-- Student Number Field -->
          <div class="mb-3">
            <label for="studentNumber" class="form-label">Numéro d'étudiant</label>
            <input type="text" class="form-control" id="studentNumber" name="studentNumber" required
              [ngModel]="student?.studentNumber" disabled>
            <div *ngIf="assistForm.submitted && assistForm.controls['studentNumber']?.invalid">
              <small class="text-danger">Ce champ est requis.</small>
            </div>
          </div>

          <!-- Email Field -->
          <div class="mb-3">
            <label for="email" class="form-label">Adresse e-mail</label>
            <input type="email" class="form-control" id="email" name="email" required
              [ngModel]="student?.email" disabled>
            <div *ngIf="assistForm.submitted && assistForm.controls['email']?.invalid">
              <small class="text-danger">Ce champ est requis.</small>
            </div>
          </div>
        </div>

        <!-- Diplomas Section -->
        <div class="mb-4" *ngIf="student?.diplomas">
          <label class="form-label mb-3">Diplômes concernés par la demande</label>
          <div class="diploma-section">
            <div *ngFor="let diploma of student?.diplomas; let i = index" class="form-check">
              <input type="checkbox" class="form-check-input" id="diploma{{i}}"
                [(ngModel)]="diploma.selected" name="diploma{{i}}" (ngModelChange)="markDiplomaTouched()"
                [disabled]="student?.diplomas?.length === 1">
              <label class="form-check-label" for="diploma{{i}}">
                {{ diploma.libWebVet }}
              </label>
            </div>
          </div>
          <div *ngIf="diplomasTouched && !isAnyDiplomaSelected()">
            <small class="text-danger">Veuillez sélectionner au moins un diplôme.</small>
          </div>
        </div>

        <!-- Student Request Section -->
        <div class="mb-4">
          <h2 class="block-title mb-3">Votre demande</h2>
          <label for="studentRequest" class="form-label">Description de votre demande</label>
          <textarea rows="10" id="studentRequest" name="studentRequest" class="form-control"
            placeholder="Décrivez votre demande en détail..." [(ngModel)]="assistanceRequest.messageContent"
            (ngModelChange)="markStudentRequestTouched()" required #demande="ngModel"></textarea>
          <div *ngIf="studentRequestTouched && demande.invalid">
            <small class="text-danger">Ce champ est requis.</small>
          </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-end gap-3 mt-4">
          <button type="button" class="btn btn-secondary" (click)="resetForm(assistForm)">
            Effacer
          </button>
          <button type="submit" class="btn btn-primary"
            [disabled]="assistForm.invalid || !isAnyDiplomaSelected() || demande.invalid">
            Envoyer
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Footer -->
  <div class="col-12 col-md-10 col-lg-8 col-xl-7 mt-4">
    <div class="text-center footer-text">
      Université Paris-Panthéon-Assas - {{ appVersion }} - {{ appEnvironment }}
    </div>
  </div>
</div>

<!-- Loading Template -->
<ng-template #loading>
  <div class="container-fluid d-flex flex-column justify-content-center align-items-center" style="height: 100vh; background-color: #fafafa;">
    <div class="text-center">
      <div class="loader mb-4"></div>
      <p class="body-text">Chargement en cours...</p>
    </div>
  </div>
</ng-template>